import { HttpInterceptorFn } from '@angular/common/http';

/**
 * Converte a busca por valor único dos lookups de regras em query param.
 *
 * O `po-combo`, no modo URL do `p-filter-service`, resolve um valor já
 * preenchido chamando `GET <url>/<valor>` — é assim que ele descobre o rótulo
 * de uma natureza ou TES ao abrir o formulário para edição.
 *
 * O roteador REST do AppServer, porém, exige correspondência exata da rota:
 * `/portalnf/regras/lookup/natureza/293014` não casa com
 * `/portalnf/regras/lookup/natureza` e devolve 404 em HTML, sem chegar ao
 * código TLPP. Testado rota a rota — só a barra final é tolerada.
 *
 * Em vez de criar cinco rotas dinâmicas no backend (e depender de uma sintaxe
 * de path param que não está documentada nesta versão), a chamada é reescrita
 * aqui para `?value=<valor>`, que o `lookupGen` já entende.
 *
 * Escopo deliberadamente estreito: só as rotas de lookup das regras.
 */
const ROTA_LOOKUP = /(portalnf\/regras\/lookup\/[a-z]+)\/([^/?]+)(\?.*)?$/i;

export const lookupValorInterceptor: HttpInterceptorFn = (req, next) => {
  if (req.method !== 'GET') {
    return next(req);
  }

  const casou = req.url.match(ROTA_LOOKUP);
  if (!casou) {
    return next(req);
  }

  const [, rota, valor, queryOriginal] = casou;
  const prefixo = req.url.slice(0, req.url.indexOf(rota));
  const separador = queryOriginal ? `${queryOriginal}&` : '?';

  return next(req.clone({
    url: `${prefixo}${rota}${separador}value=${encodeURIComponent(valor)}`
  }));
};
